
import templateUrl from './contact-invoices.tpl.html';
import createModalTemplate from '../../../../billing/invoices/views/create-modal.tpl.html';

class ContactInvoicesCtrl {

    constructor(Invoice, $injector, $state, Invoices) {
        this.model = Invoice;
        this.injector = $injector;
        this.state = $state;
        this.uibModal = $injector.get('$uibModal');
        this.invoicesStore = Invoices;
        this.alert = $injector.get('Alert');
        this.api = $injector.get('$http');
    }

    $onInit() {
        this.store = this.invoicesStore.reset({
            persists: true,
            listview: 'ContactDetailsInvoices'
        });
        this.store.dispatch('loadWorkflows', 'billing::invoice-list');
        this.store.commit('setVisible', [
            'subject',
            'template.title',
            'invoice_number',
            'status',
            'sum_after_tax',
            'shipping_costs'
        ]);
        this.store.commit('setPrefix', 'billing/contacts/' + this.contact.id);
        this.store.commit('addAction', {
            key: 'new_bid',
            title: 'New Bid',
            icon: 'plus-circle',
            level: 'highlight',
            vm: 'createNewBid'
        });

        this.store.commit('addAction', {
            key: 'new_invoice',
            title: 'New Invoice',
            icon: 'plus-circle',
            level: 'highlight',
            vm: 'createNewInvoice'
        });
        this.store.commit('addAction', {
            key: 'new_commission',
            title: 'New Commission Invoice',
            icon: 'plus-circle',
            level: 'highlight',
            vm: 'createNewCommissionInvoice'
        });
        this.store.commit('addAction', {
            key: 'prepare_shipping',
            title: 'Prepare Shipping',
            icon: 'sync',
            level: 'highlight',
            vm: 'prepareShipping'
        });
        this.store.commit('addAction', {
            key: 'new_cancellation',
            title: 'New Cancellation',
            icon: 'plus-circle',
            level: 'highlight',
            vm: 'createNewCancellation'
        });

        this.store.commit('setVm', this);
    }

    createNewInvoice() {
        this.createNewDocument('invoice');
    }

    createNewCommissionInvoice() {
        this.createNewDocument('commission');
    }

    createNewBid() {
        this.createNewDocument('bid');
    }

    createNewCancellation() {
        this.createNewDocument('cancellation');
    }

    prepareShipping() {
        this.api.post('contacts/prepare-shipping-for-upcoming', {
            contacts: {
                filters: [{field: 'id', operator: '=', value: this.contact.id}],
                count: 1
            }
        }).then(() => {
            this.alert.success('Success', 'Shipping addresses have been prepared');
        }, () => {
            this.alert.error('Error', 'Prepare shipping addresses failed');
        });
    }

    createNewDocument(type) {
        const modal = this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: createModalTemplate,
            size: 'xlg',
            controller: 'InvoicesCreateModalCtrl',
            controllerAs: 'vm',
            resolve: {
                type: () => {
                    return type;
                },
                entity: () => {
                    return {
                        contactId: this.contact.id,
                        id: this.contact.id,
                        type: 'contact'
                    };
                }
            }
        }).result.then(() => {
            this.store.dispatch('getData');
        });
    }

    showDetails(action) {
        this.state.go('app.billing.invoices.details', {id: action.row.id});
    }
}


ContactInvoicesCtrl.$inject = ['Invoice', '$injector', '$state', 'Invoices'];


angular
    .module('festzelt-os.contacts')
    .component('contactInvoices', {
        bindings: {
            contact: '='
        },
        controller: ContactInvoicesCtrl,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/invoices/contact-invoices.js